import { FilterList } from "@mui/icons-material";
import { Box, Button, useTheme } from "@mui/material";
import { FC, useMemo } from "react";
import { useLocalization } from "../../../../hooks/useLocalization";

interface FilterButtonDesktopProps {
  label: string;
  selectedCount: number;
  totalCount: number;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  emptySelectionMode?: "all" | "zero";
}

export const FilterButtonDesktop: FC<FilterButtonDesktopProps> = ({
  label,
  selectedCount,
  onClick,
  totalCount,
  emptySelectionMode = "all",
}) => {
  const theme = useTheme();
  const { t } = useLocalization();

  const secondaryText = useMemo(() => {
    if (selectedCount === 0) {
      return emptySelectionMode === "zero"
        ? "(0)"
        : `(${t("components.filterSelect.all")})`;
    }
    if (selectedCount === totalCount) {
      return `(${t("components.filterSelect.all")})`;
    }

    return `(${selectedCount})`;
  }, [selectedCount, totalCount, t, emptySelectionMode]);

  return (
    <Button
      endIcon={<FilterList sx={{ height: 16, width: 16 }} />}
      onClick={onClick}
      size="small"
      sx={{
        backgroundColor: "transparent",
        borderRadius: "16px",
        color: selectedCount > 0 ? theme.colors.text[6] : theme.colors.text[3],
        fontSize: 12,
        fontWeight: 500,
        height: 32,
        width: "fit-content",
        "& .MuiButton-endIcon": {
          marginLeft: 0,
        },
        "&:hover": {
          backgroundColor: theme.colors.secondary[0],
          textDecoration: "underline",
        },
      }}
      variant="contained"
    >
      {label}
      <Box
        sx={{
          minWidth: 32,
          textAlign: "left",
          ml: 0.5,
        }}
      >
        {secondaryText}
      </Box>
    </Button>
  );
};
